import React, { useEffect, useState, FC } from "react";
import { Tabs, Tab, TabPanel, TabList } from "react-tabs";
import "react-tabs/style/react-tabs.css";
import ProjectPendingTable from "./Tables/ProjectPendingTable";
import ProjectApprovedTable from "./Tables/ProjectApprovedTable";
import ProjectRejectedTable from "./Tables/ProjectRejectedTable";
import axios from "axios";
import { isAuth } from "../../../pages/auth/ProtectedRoute";
const ProjectManagementTab: FC = () => {
  const [pendingTotal, setPendingTotal] = useState<number>(0);
  const [approvedTotal, setApprovedTotal] = useState<number>(0);
  const [rejectedTotal, setRejectedTotal] = useState<number>(0);

  const getPendingTotal = (newValue: number) => {
    setPendingTotal(newValue);
  };
  useEffect(() => {
    axios({
      method: "GET",
      url: process.env.REACT_APP_HOST_API + `projects/approved`,
      headers: {
        Authorization: `Bearer ${isAuth()}`,
      },
    })
      .then((res) => {
        if (res.data.response === true && res.data.status === 200) {
          setApprovedTotal(res?.data?.data?.data?.length || 0);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    axios({
      method: "GET",
      url: process.env.REACT_APP_HOST_API + `projects/rejected`,
      headers: {
        Authorization: `Bearer ${isAuth()}`,
      },
    })
      .then((res) => {
        if (res.data.response === true && res.data.status === 200) {
          setRejectedTotal(res?.data?.data?.data?.length || 0);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  return (
    <div className="task-dashboard">
      <div className="project-table" style={{ 
        display: "flex", 
        flexDirection: "column",
      }}>
        <Tabs style={{ flex: 1 }}>
          <TabList
            style={{
              borderBottom: "none",
              margin: 0,
              display: "flex",
              alignItems: "center"
            }}
          >
            <Tab className="project-tab">
              <span className="tab-label">Pending Approval</span>
              <span className="tab-count">{pendingTotal}</span>
            </Tab>
            <div style={{ height: "20px", width: "1px", background: "#E8E8E8", margin: "0 25px" }}></div>
            <Tab className="project-tab">
              <span className="tab-label">Approved</span>
              <span className="tab-count">{approvedTotal}</span>
            </Tab>
            <div style={{ height: "20px", width: "1px", background: "#E8E8E8", margin: "0 25px" }}></div>
            <Tab className="project-tab">
              <span className="tab-label">Rejected</span>
              <span className="tab-count">{rejectedTotal}</span>
            </Tab>
          </TabList>

          <TabPanel className="pending-button">
            <ProjectPendingTable getPendingTotal={getPendingTotal} />
          </TabPanel>
          <TabPanel className="approval-button">
            <ProjectApprovedTable />
          </TabPanel>
          <TabPanel className="approval-button">
            <ProjectRejectedTable />
          </TabPanel>
        </Tabs>
      </div>
    </div>
  );
};
export default ProjectManagementTab;
